<template>
    <div>
        <div class="timeLine">
            <div ref="timerShaft" ></div>
        </div>
        <div class="messageAndChart">
            <div class="leftMessage">
                <el-table :data='dataList'>

                    <el-table-column label="" prop="id" width='40'>
                        <template slot-scope='{ row }'>
                            <span>
                                <img :src='getImgUrl(row.icon_colour)' style='width: 20px;height: 20px;'>
                            </span>
                        </template>
                    </el-table-column>

                    <el-table-column label="构建" sortable :sort-method='fn'>
                        <template slot-scope='{ row }'>
                            <span>
                                ID: {{row.id}} 发布人: {{row.user_cn_name}}
                            </span>
                        </template>
                    </el-table-column>

                    <el-table-column label="持续时间" sortable :sort-method='fn'>
                        <template slot-scope='{ row }'>
                            <span>
                                {{ row.duration |  getDuration()}}
                            </span>
                        </template>
                    </el-table-column>

                </el-table>
            </div>
            <div ref="myChart" class="rightChart"></div>
        </div>
    </div>
</template>

<script>
    import Echarts from 'echarts'

    import services from '../../cicd.services'

    import { imgMessage } from '../../cicd.config'
    const imgList = imgMessage()
    export default {
        data() {
            return {
                dataList: [],
                imgList
            }
        },

        watch: {
            query() {
                this.request()
            }
        },

        computed: {
            query() {
                return this.$route.params
            },
        },

        mounted(){
            this.request()
        },

        methods: {
            fn(a, b) {
            },
            // 获取图片路径
            getImgUrl(val) {
                let arr = this.imgList.filter(item => item.id === val)
                return arr[0].name
            },

            // 获取数据
            request() {
                services.HistoryMessage(this.query)
                    .then(res => {
                        this.dataList = res.list
                        this.getEcharts()
                        this.getTimerShaft()
                    })
                    .catch(err => this.$message.error(err.message))
            },

            getEcharts(){ //折线图
                let myChart = Echarts.init(this.$refs.myChart)
                myChart.setOption({
                    tooltip : {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            animation: false,
                            label: {
                                backgroundColor: '#505765'
                            }
                        }
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type : 'category',
                        boundaryGap : false,
                        splitLine: {show: false},
                        axisLine: {onZero: false},
                        data: this.dataList.map(item => `ID:${item.id} 发布人:${item.user_cn_name}`)
                    },
                    yAxis: {
                        type : 'value',
                        splitLine: {show: false}
                    },
                    series: [
                        {
                            type: 'line',
                            areaStyle: {},
                            type:'line',
                            yAxisIndex:0,
                            lineStyle: {
                                width: 0
                            },
                            data: this.dataList.map((item, index) => item.duration)
                        },
                    ]
                });
            },

            getTimerShaft() { // 时间轴
                let timerShaft = Echarts.init(this.$refs.timerShaft)
                timerShaft.setOption({
                    tooltip : {
                        trigger: 'axis'
                    },
                    calculable : true,
                    xAxis: {
                        type : 'category',
                        boundaryGap : false,
                        splitLine: {show: false},
                         data : this.dataList.map(item => `ID:${item.id} 发布人:${item.user_cn_name}`)
                    },
                    yAxis: {
                        type : 'value',
                        splitLine: {show: false},
                    },
                    series: [
                        {
                            
                            name:'',
                            type:'line',
                            stack: '总量',
                            data: this.dataList.map((item, index) => item.duration)
                        },
                    ]
                })
            }
        }
    }
</script>

<style lang='scss' scoped>
    .timeLine{
        width:900px;
        height: 250px;
        >div {
            width: 900px;
            height: 250px;
        }
    }
    .messageAndChart{
        display: flex;
        margin-top: 10px;
        .leftMessage{
            width: 370px;
            height: 500px;
            overflow-y: auto;
            padding-right: 20px;
        }
        .rightChart{
            width: 500px;
            height: 500px;
        }
    }
</style>
